const REVIEWS = [
  {
    id: 1,
    photo: '/assets/Ellipse 1.png',
    name: 'Alex andrina',
    reviewStar: 5,
    reviewBody:
      '“Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras. Quisque commodo mattis ornare a nec odio. Pulvinar orci, egestas eget nulla duis at iaculis nunc, elit. “'
  },
  {
    id: 2,
    photo: '/assets/Ellipse 2.png',
    name: 'Alex andrina',
    reviewStar: 4,
    reviewBody:
      '“Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras. Quisque commodo mattis ornare a nec odio. Pulvinar orci, egestas eget nulla duis at iaculis nunc, elit. “'
  },
  {
    id: 3,
    photo: '/assets/Ellipse 1.png',
    name: 'Alex andrina',
    reviewStar: 5,
    reviewBody:
      '“Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sollicitudin hendrerit a amet viverra. Nunc pretium in amet at mattis cras. Quisque commodo mattis ornare a nec odio. Pulvinar orci, egestas eget nulla duis at iaculis nunc, elit. “'
  }
];
export default REVIEWS;